import styled from 'styled-components'

export const CardContainer = styled.div`
    width: 392px;
    height: min-content;
    margin-top: 8px;
    overflow: hidden;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;

    @media (max-width: 768px) {
        margin: auto;
        width: 100%;
        margin-bottom: 1rem;
    }
`

export const TopSection = styled.div<{ $image: string }>`
    width: 365px;
    height: 300px;
    background-image: url(${({ $image }) => $image});
    background-size: cover;
    background-position: center;
    margin-left: 8px;
    border: 1px solid #ccc;
    border-bottom: none;
    margin-right: 8px;

    @media (max-width: 768px) {
        width: 100%;
    }
`

export const MiddleSection = styled.div`
    width: 390px;
    height: 50px;
    background-color: #ba9d31;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    @media (max-width: 768px) {
        width: 110%;
        left: 0;
    }
`

export const Title = styled.p`
    color: #fff;
    max-width: 20rem;
    font-weight: 600;
    position: relative;
    font-size: 20px;
    font-family: 'Poppins', sans-serif;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    @media (max-width: 768px) {
        font-size: 18px;
        white-space: normal;
        text-align: center;
    }
`

export const BottomSection = styled.div`
    width: 365px;
    max-height: 350px;
    padding: 16px;
    box-sizing: border-box;
    color: #000;
    font-size: 14px;
    border: 1px solid #ccc;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
    margin-left: 8px;
    margin-right: 8px;

    display: -webkit-box;
    -webkit-line-clamp: 12;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: break-word;
    word-break: break-word;

    @media (max-width: 768px) {
        box-shadow: none;
        border: 1px solid #ccc;
        width: 100%;
    }
`
